import type { PropsWithChildren } from "react";
import { cn } from "@design-lab/shared/lib/tailwindcss";

export type FeedbackToolbarBoxProps = {
  className?: string;
};

export function FeedbackToolbarBox({
  children,
  className
}: PropsWithChildren<FeedbackToolbarBoxProps>) {
  return (
    <div
      className={cn(
        "m-auto mb-2 flex w-fit max-w-full items-center gap-2 rounded-xl bg-white px-2.5 py-1 shadow-md",
        className
      )}
      data-testid="artwork-feedback"
    >
      {children}
    </div>
  );
}
